// extracted by mini-css-extract-plugin
export default {"dropdownButton":"AdminUserListAction_dropdownButton__-kUia","dropdownItem":"AdminUserListAction_dropdownItem__ufE8B"};